

























































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";

import {
  DrivewealthWizardStep,
  RiskQuizGeneralHealth,
  RiskQuizSellForExpenses,
  RiskQuizGoal,
  RiskQuizReconsiderStrategy,
  RiskQuizStartWithdrawing,
  RiskToleranceQuestionnaireField,
  RiskToleranceQuestionnaireAnswer,
  RiskToleranceQuestionnaireForm
} from "@/shared/types";
import { Validator } from "vee-validate";
import * as drivewealth from "@/shared/custodianSettings/drivewealthTypes";
import InstrumentName from "./InstrumentName.vue";
import WizardProgress from "@/employee/components/investments/drivewealth/wizard/WizardProgress.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import * as RouteNames from "@/employee/route-names";
import { useNotifierStore } from "@/shared/store/notifier";
import { useDrivewealthInvestmentStrategy } from "@/shared/store/drivewealthInvestmentStrategy";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useRiskToleranceQuestionnaireStore } from "@/shared/store/riskToleranceQuestionnaire";

@Component({
  components: {
    InstrumentName,
    WizardProgress,
    GenericLoadingSpinner
  }
})
export default class ManagedAccountQuestions extends Vue {
  $validator: Validator;
  isSubmitting = false;
  notifierStore = useNotifierStore();
  startWithdrawingContainer = drivewealth.startWithdrawingFactory();
  goalContainer = drivewealth.goalFactory();
  generalHealthContainer = drivewealth.generalHealthFactory();
  sellForExpensesContainer = drivewealth.sellForExpensesFactory();
  reconsiderContainer = drivewealth.reconsiderFactory();
  questionaireFactory = drivewealth.RtqQuestionaireFactory();
  managedRiskQuestionnaireQuestions = drivewealth.ManagedRiskToleranceQuestionnaireFields;

  investmentStrategyStore = useDrivewealthInvestmentStrategy();
  drivewealthWizardStore = useDrivewealthWizardStore();
  custodianSettingsStore = useCustodianSettingsStore();
  riskToleranceQuestionnaireStore = useRiskToleranceQuestionnaireStore();

  @Prop({ required: true })
  isWizard: boolean;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: false })
  currentPortfolioId: string;

  @Prop({ required: false })
  accountId: number;

  @Watch("$props", { deep: true })
  loadAnswers () {
    this.investmentStrategyStore.getQuestionnaire({ username: this.username, partnerId: this.partnerId });
  }

  get isHsabInvestManagedFlow (): boolean {
    return this.custodianSettingsStore.isHsaBankCustodian;
  }

  get wizardRoute () {
    return RouteNames.DrivewealthWizard;
  }

  get step () {
    return DrivewealthWizardStep.PortfolioSelection;
  }

  get previousWizardStep () {
    return this.drivewealthWizardStore.getPreviousWizardStep(this.step);
  }

  get generalHealth () {
    return this.investmentStrategyStore.questionnaireGeneralHealth;
  }

  set generalHealth (value: RiskQuizGeneralHealth) {
    this.investmentStrategyStore.setQuestionnaireResponse({ key: "generalHealth", value });
  }

  get goal () {
    return this.investmentStrategyStore.questionnaireGoal;
  }

  set goal (value: RiskQuizGoal) {
    this.investmentStrategyStore.setQuestionnaireResponse({ key: "goal", value });
  }

  get sellForExpenses () {
    return this.investmentStrategyStore.questionnaireSellForExpenses;
  }

  set sellForExpenses (value: RiskQuizSellForExpenses) {
    this.investmentStrategyStore.setQuestionnaireResponse({ key: "sellForExpenses", value });
  }

  get startWithdrawing () {
    return this.investmentStrategyStore.questionnaireStartWithdrawing;
  }

  set startWithdrawing (value: RiskQuizStartWithdrawing) {
    this.investmentStrategyStore.setQuestionnaireResponse({ key: "startWithdrawing", value });
  }

  get reconsider () {
    return this.investmentStrategyStore.questionnaireReconsiderStrategy;
  }

  set reconsider (value: RiskQuizReconsiderStrategy) {
    this.investmentStrategyStore.setQuestionnaireResponse({ key: "reconsiderStrategy", value });
  }

  mounted () {
    this.loadAnswers();
  }

  setIsSubmitting (value: boolean) {
    this.isSubmitting = value;
    this.$emit("isSubmitting", value);
  }

  tryEvaluate () {
    this.$validator
        .validate()
        .then(result => {
          if (!result) {
            return;
          }

          this.setIsSubmitting(true);

          if (this.isHsabInvestManagedFlow) {
            const questionsCount: number = this.managedRiskQuestionnaireQuestions.length;
            const userResponses: RiskToleranceQuestionnaireAnswer[] = this.managedRiskQuestionnaireQuestions.map(x => {
              if (x.userResponse) {
                return x.userResponse;
              }
            });

            if (questionsCount !== userResponses.length) {
              return;
            }

            const formModel: RiskToleranceQuestionnaireForm = {
              userResponses,
              accountId: this.accountId
            };
            this.riskToleranceQuestionnaireStore.evaluateMangedRtqAnswers(formModel)
            .then(_ => {
                this.setIsSubmitting(false);

                if (this.isWizard) {
                  this.drivewealthWizardStore.setWizardStepComplete(this.step);
                } else {
                  this.$emit("quizAnswered");
                }
              })
              .catch(err => {
                this.notifierStore.setDanger(
                    (err && err.errorMessage) || "Error processing your request. Please try again later");
                this.setIsSubmitting(false);
              });
          } else {
            this.investmentStrategyStore.evaluateQuestionnaire()
              .then(_ => {
                this.setIsSubmitting(false);

                if (this.isWizard) {
                  this.drivewealthWizardStore.setWizardStepComplete(this.step);
                } else {
                  this.$emit("quizAnswered");
                }
              })
              .catch(err => {
                this.notifierStore.setDanger(
                    (err && err.errorMessage) || "Error processing your request. Please try again later");
                this.setIsSubmitting(false);
              });
          }
        });
  }
}
